<template>
  <section>
    <nav-component :titulo="'Choferes'" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Choferes</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="table-toolbar">
      <div class="table-toolbar-left">
        <b-button type="is-primary" size="is-small" icon-left="plus" @click="mostrarNuevoChofer = true">
          Registrar chofer
        </b-button>
        <b-select v-model="porPagina" @input="cambiarPorPagina" size="is-small">
          <option :value="10">10 / pág</option>
          <option :value="20">20 / pág</option>
          <option :value="50">50 / pág</option>
        </b-select>
        <span style="font-size:0.78rem;color:var(--color-text-dim)">{{ total }} choferes</span>
      </div>
      <div class="table-toolbar-right">
        <b-button type="is-primary" size="is-small" icon-left="printer" tag="a" href="#/pdf/choferes" target="_blank" rel="noopener noreferrer">
          Imprimir
        </b-button>
      </div>
    </div>

    <!-- Modal nuevo chofer -->
    <b-modal v-model="mostrarNuevoChofer" has-modal-card trap-focus :destroy-on-hide="true">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Registrar nuevo chofer</p>
          <button type="button" class="delete" @click="mostrarNuevoChofer = false" />
        </header>
        <section class="modal-card-body">
          <form-chofer @registrar="registrarChofer" @cancelar="mostrarNuevoChofer = false" :formatoMonto="formatoMonto" />
        </section>
      </div>
    </b-modal>

    <b-table
      class="box"
      :data="choferes"
      :paginated="true"
      :per-page="porPagina"
      :current-page="pagina"
      :total="total"
      :backend-pagination="true"
      :pagination-rounded="true"
      pagination-position="bottom"
      @page-change="onCambioPagina"
    >
      <b-table-column field="nombre"   label="Nombre"     sortable v-slot="props">{{ props.row.nombre }}</b-table-column>
      <b-table-column field="ci"       label="Cédula/RIF" sortable v-slot="props">{{ props.row.ci }}</b-table-column>
      <b-table-column field="tipo"     label="Tipo"       sortable v-slot="props">{{ props.row.tipo }}</b-table-column>
      <b-table-column field="telefono" label="Teléfono"   sortable v-slot="props">{{ props.row.telefono }}</b-table-column>
      <b-table-column field="deuda"    label="Deuda"      sortable v-slot="props">
        <span :class="Number(props.row.deuda) > 0 ? 'has-text-danger' : 'has-text-success'">
          ${{ formatoMonto(props.row.deuda) }}
        </span>
      </b-table-column>
      <b-table-column label="Acciones" v-slot="props">
        <div class="is-flex" style="gap:4px">
          <b-button v-if="can('choferes.editar')" type="is-info" size="is-small" icon-left="pen"
            tag="router-link" :to="{ name: 'EditarChofer', params: { id: props.row.id } }" />
          <b-button v-if="tieneDeuda(props.row) && can('choferes.pagar_chofer')" type="is-success" size="is-small" icon-left="currency-usd" @click="pagar(props.row)">
            Pagar
          </b-button>
        </div>
      </b-table-column>
    </b-table>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import NavComponent from '../Extras/NavComponent'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import FormChofer from './FormChofer.vue'

export default {
  name: "ChoferesComponent",
  components: { NavComponent, FormChofer },

  data: () => ({
    cargando: false,
    choferes: [],
    pagina: 1,
    porPagina: 20,
    total: 0,
    mostrarNuevoChofer: false,
  }),

  mounted() {
    this.obtenerChoferes()
  },

  methods: {
    formatoMonto(v) { return Utiles.formatoMonto(v) },
    tieneDeuda(c) { return Number(c.deuda) > 0 },

    onCambioPagina(p) { this.pagina = p; this.obtenerChoferes() },
    cambiarPorPagina() { this.pagina = 1; this.obtenerChoferes() },

    obtenerChoferes() {
      this.cargando = true
      HttpService.obtenerConConsultas("choferes.php", {
        accion: "obtener",
        pagina: this.pagina,
        porPagina: this.porPagina,
      }).then(resp => {
        if (Array.isArray(resp)) {
          this.choferes = resp; this.total = resp.length
        } else {
          this.choferes = resp.choferes || resp.data || []
          this.total = resp.total || this.choferes.length
        }
        this.cargando = false
      })
    },

    pagar(chofer) {
      this.$buefy.dialog.prompt({
        message: '¿Monto del pago a registrar?',
        cancelText: 'Cancelar', confirmText: 'Registrar',
        inputAttrs: { type: 'number', placeholder: 'Monto', min: 0.01, max: Number(chofer.deuda), step: 0.01 },
        trapFocus: true,
        onConfirm: (value) => {
          this.cargando = true
          HttpService.registrar('choferes.php', { accion: 'pagar_chofer', pago: { monto: value, idChofer: chofer.id } })
            .then(ok => {
              this.cargando = false
              if (ok) { this.$buefy.toast.open('Pago registrado con éxito.'); this.obtenerChoferes() }
            })
        }
      })
    },

    registrarChofer(datos) {
      this.cargando = true
      this.mostrarNuevoChofer = false
      HttpService.registrar('choferes.php', { accion: 'registrar', chofer: datos })
        .then(() => {
          this.obtenerChoferes()
          this.$buefy.toast.open('Chofer registrado con éxito.')
          this.cargando = false
        })
        .catch(() => {
          this.$buefy.toast.open({ message: 'Error al registrar chofer.', type: 'is-danger' })
          this.cargando = false
        })
    }
  },
}
</script>
